import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type INotificationCustomFilterFieldsFragment = {
  id?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  version?: number | null
  projectId: any
  name: string
  userId?: any | null
  isPublic: boolean
  defaultForUsers?: Array<any | null> | null
  groupBy?: string | null
  filtersByFilterType?: Array<{
    type?: Types.NotificationFilterType | null
    values?: Array<string | null> | null
  } | null> | null
}

export type IGetNotificationCustomFiltersByProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetNotificationCustomFiltersByProjectQuery = {
  notificationCustomFilters?: {
    data: Array<{
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      version?: number | null
      projectId: any
      name: string
      userId?: any | null
      isPublic: boolean
      defaultForUsers?: Array<any | null> | null
      groupBy?: string | null
      filtersByFilterType?: Array<{
        type?: Types.NotificationFilterType | null
        values?: Array<string | null> | null
      } | null> | null
    }>
  } | null
}

export type ISaveNotificationCustomFilterMutationVariables = Types.Exact<{
  filter: Types.INotificationCustomFilterInput
}>

export type ISaveNotificationCustomFilterMutation = {
  saveNotificationCustomFilter?: {
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    version?: number | null
    projectId: any
    name: string
    userId?: any | null
    isPublic: boolean
    defaultForUsers?: Array<any | null> | null
    groupBy?: string | null
    filtersByFilterType?: Array<{
      type?: Types.NotificationFilterType | null
      values?: Array<string | null> | null
    } | null> | null
  } | null
}

export type IDeleteNotificationCustomFilterMutationVariables = Types.Exact<{
  filterId: Types.Scalars['ObjectId']['input']
}>

export type IDeleteNotificationCustomFilterMutation = {
  deleteNotificationCustomFilter?: boolean | null
}

export const NotificationCustomFilterFieldsFragmentDoc = gql`
  fragment NotificationCustomFilterFields on NotificationCustomFilter {
    id
    createdAt
    updatedAt
    version
    projectId
    name
    userId
    isPublic
    filtersByFilterType {
      type
      values
    }
    defaultForUsers
    groupBy
  }
`
export const GetNotificationCustomFiltersByProjectDocument = gql`
  query GetNotificationCustomFiltersByProject($projectId: ObjectId!) {
    notificationCustomFilters(limit: 1000, projectId: $projectId) {
      data {
        ...NotificationCustomFilterFields
      }
    }
  }
  ${NotificationCustomFilterFieldsFragmentDoc}
`

/**
 * __useGetNotificationCustomFiltersByProjectQuery__
 *
 * To run a query within a React component, call `useGetNotificationCustomFiltersByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationCustomFiltersByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationCustomFiltersByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetNotificationCustomFiltersByProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetNotificationCustomFiltersByProjectQuery,
    IGetNotificationCustomFiltersByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetNotificationCustomFiltersByProjectQuery,
    IGetNotificationCustomFiltersByProjectQueryVariables
  >(GetNotificationCustomFiltersByProjectDocument, options)
}
export function useGetNotificationCustomFiltersByProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetNotificationCustomFiltersByProjectQuery,
    IGetNotificationCustomFiltersByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetNotificationCustomFiltersByProjectQuery,
    IGetNotificationCustomFiltersByProjectQueryVariables
  >(GetNotificationCustomFiltersByProjectDocument, options)
}
export type GetNotificationCustomFiltersByProjectQueryHookResult = ReturnType<
  typeof useGetNotificationCustomFiltersByProjectQuery
>
export type GetNotificationCustomFiltersByProjectLazyQueryHookResult =
  ReturnType<typeof useGetNotificationCustomFiltersByProjectLazyQuery>
export type GetNotificationCustomFiltersByProjectQueryResult =
  Apollo.QueryResult<
    IGetNotificationCustomFiltersByProjectQuery,
    IGetNotificationCustomFiltersByProjectQueryVariables
  >
export const SaveNotificationCustomFilterDocument = gql`
  mutation SaveNotificationCustomFilter(
    $filter: NotificationCustomFilterInput!
  ) {
    saveNotificationCustomFilter(notificationCustomFilter: $filter) {
      ...NotificationCustomFilterFields
    }
  }
  ${NotificationCustomFilterFieldsFragmentDoc}
`
export type ISaveNotificationCustomFilterMutationFn = Apollo.MutationFunction<
  ISaveNotificationCustomFilterMutation,
  ISaveNotificationCustomFilterMutationVariables
>

/**
 * __useSaveNotificationCustomFilterMutation__
 *
 * To run a mutation, you first call `useSaveNotificationCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationCustomFilterMutation, { data, loading, error }] = useSaveNotificationCustomFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSaveNotificationCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveNotificationCustomFilterMutation,
    ISaveNotificationCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveNotificationCustomFilterMutation,
    ISaveNotificationCustomFilterMutationVariables
  >(SaveNotificationCustomFilterDocument, options)
}
export type SaveNotificationCustomFilterMutationHookResult = ReturnType<
  typeof useSaveNotificationCustomFilterMutation
>
export type SaveNotificationCustomFilterMutationResult =
  Apollo.MutationResult<ISaveNotificationCustomFilterMutation>
export type SaveNotificationCustomFilterMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveNotificationCustomFilterMutation,
    ISaveNotificationCustomFilterMutationVariables
  >
export const DeleteNotificationCustomFilterDocument = gql`
  mutation DeleteNotificationCustomFilter($filterId: ObjectId!) {
    deleteNotificationCustomFilter(id: $filterId)
  }
`
export type IDeleteNotificationCustomFilterMutationFn = Apollo.MutationFunction<
  IDeleteNotificationCustomFilterMutation,
  IDeleteNotificationCustomFilterMutationVariables
>

/**
 * __useDeleteNotificationCustomFilterMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationCustomFilterMutation, { data, loading, error }] = useDeleteNotificationCustomFilterMutation({
 *   variables: {
 *      filterId: // value for 'filterId'
 *   },
 * });
 */
export function useDeleteNotificationCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteNotificationCustomFilterMutation,
    IDeleteNotificationCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteNotificationCustomFilterMutation,
    IDeleteNotificationCustomFilterMutationVariables
  >(DeleteNotificationCustomFilterDocument, options)
}
export type DeleteNotificationCustomFilterMutationHookResult = ReturnType<
  typeof useDeleteNotificationCustomFilterMutation
>
export type DeleteNotificationCustomFilterMutationResult =
  Apollo.MutationResult<IDeleteNotificationCustomFilterMutation>
export type DeleteNotificationCustomFilterMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteNotificationCustomFilterMutation,
    IDeleteNotificationCustomFilterMutationVariables
  >
